<template>
  <div id="addon-port-master-destination-work-list">
    <div class="card vx-card p-6">
      <div class="upper-controller" v-if="isImportEditMode">
        <div class="icon-area">
          <feather-icon
            icon="DownloadIcon"
            svgClasses="h-7 w-7"
          />
        </div>
        <p class="display-label">一括取込み</p>
        <vs-button
          class="save-button top-button"
          color="#2D9CDB"
          @click="clickSaveButton"
        >
          <div class="button-inner">
            <span>保存</span>
          </div>
        </vs-button>
      </div>
      <div class="upper-controller" v-else>
        <div class="icon-area">
          <feather-icon
            icon="MonitorIcon"
            svgClasses="h-7 w-7"
          />
        </div>
        <p class="display-label">管理者画面</p>

        <v-select
          class="display-items-select-box"
          v-model="selectedDate"
          :options="dateOptions"
          label="date"
          placeholder="選択してください"
          :clearable="false"
          :searchable="false"
        >
          <template #selected-option="option">
            <span>
              {{convertToDisplayDate(option.date)}}
            </span>
          </template>
          <template v-slot:option="option">
            <span>
              {{convertToDisplayDate(option.date)}}
            </span>
          </template>
        </v-select>
        <span class="last-updated-text">最終更新：{{lastUpdatedTimeMap[selectedDate]}}</span>
        <vs-button
          class="add-button top-button"
          color="#2D9CDB"
          type="border"
          @click="openInsertOne"
        >
          <div class="button-inner">
            <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-5 w-5" />
            <span>新規登録</span>
          </div>
        </vs-button>
        <vs-button
          class="row-order-button top-button"
          color="#2D9CDB"
          type="border"
          @click="clickRowSortButton"
        >
          <div class="button-inner">
            <feather-icon class="mr-2" icon="ListIcon" svgClasses="h-5 w-5" />
            <span>表示順序変更</span>
          </div>
        </vs-button>
        <vs-button
          class="column-order-button top-button"
          color="#2D9CDB"
          type="border"
          @click="clickColumnSortButton"
        >
          <div class="button-inner">
            <feather-icon class="mr-2" icon="ColumnsIcon" svgClasses="h-5 w-5" />
            <span>項目順序変更</span>
          </div>
        </vs-button>
      </div>
      <div class="flex destination-work-top" style="margin-bottom:2rem;width:90%;">
      <div class="flex w-1/2 justify-start">
        <!-- ポップアップの表示/非表示 -->
        <vs-popup
          :active.sync="showPopupDate"
          class="pmdw-popup"
          :id="'display_date_popup'"
          title="日付"
        >
          <div class="flex justify-center" style="padding:1rem;">
            <div class="vs-col" v-for="(displayDate,index) in displayDateList" :key="index" style="margin:0.2rem;">
              <vs-button
                :color="(selectedDisplayDateId === displayDate.id) ? '#346c88' : '#828282' "
                @mousedown="selectedDisplayDateId = displayDate.id"
              >
                {{ displayDate.name }}
              </vs-button>
            </div>
          </div>
          <div class="flex justify-center">
            <vs-button
            color="#2d9cdb"
            style="margin:0 1rem;width:30%"
            @mousedown="onChangeDate"
            >保存</vs-button>
          </div>
        </vs-popup>
      </div>
    </div>

    <div class="pm-click-jacking-mask">
      <div id="vessel-header" class="pm-click-jacking" @mousedown="toggleVesselNameJapaneseFlg" ></div>
    </div>

    <div style="margin:1rem 0;">
      <ag-grid-vue
        ref="agGridTable1"
        :rowData="destinationWorkTasks"
        :gridOptions="gridOptions1"
        :columnDefs="columnDefs1"
        :defaultColDef="defaultColDef"
        :components="components"
        rowSelection="multiple"
        colResizeDefault="shift"
        :floatingFilter="false"
        :enableRtl="$vs.rtl"
        :rowDragManaged="true"
        :animateRows="true"
        class="ag-theme-material ag-grid-table pm-ag-grid-vue"
        :class="{'drag-disabled': gridOptions1.context.dragDisabled}"
      >
      </ag-grid-vue>

      <cell-summary-dialog
        :showPopup.sync="showPopupSync"
        :clickX="clickX"
        :clickY="clickY"
        :popupTitle="popupTitle"
        :popupTaskId="popupTaskId"
        :popupColumnKey="popupColumnKey"
        :popupValueMap="popupValueMap"
        :isImportEditMode="isImportEditMode"
        :isInsertOneMode="isInsertOneMode"
        @updateGridCell="updateGridCell"
      />


    </div>

    <!-- １行新規作成用ダイアログ -->
    <div class="insert-one-overlay"  v-show="isInsertOneMode" >
      <div class="insert-one-content">
        <div class="flex justify-end">
          <div class="insert-one-close-button" @click="isInsertOneMode = false" > × </div>
        </div>

        <ag-grid-vue
          ref="agGridTable0"
          :rowData="destinationWorkTasks0"
          :gridOptions="gridOptions0"
          :columnDefs="columnDefs0"
          :defaultColDef="defaultColDef"
          :components="components"
          rowSelection="multiple"
          colResizeDefault="shift"
          :floatingFilter="false"
          :enableRtl="$vs.rtl"
          :animateRows="true"
          class="ag-theme-material ag-grid-table pm-ag-grid-vue"
          :class="{'drag-disabled': true}"
        >
        </ag-grid-vue>

        <div class="flex justify-end">
          <vs-button
            style="margin:0.5rem;"
            color="#bdbdbd"
            @click="isInsertOneMode = false"
          >
            キャンセル
          </vs-button>
          <vs-button
            style="margin:0.5rem;"
            color="#2d9cdb"
            :disabled="!isOneTaskValid"
            @click="submitInsertOne"
          >
            登録
          </vs-button>
        </div>
      </div>
    </div>

    <error-dialog
      ref="errorDialog"
    ></error-dialog>

    </div>


  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import moment from "moment-timezone";
import CellRendererItem from "./components/CellRendererItem";
import CellSummaryDialog from "./components/CellSummaryDialog";
import ErrorDialog from "../components/ErrorDialog";
import { AgGridVue } from "ag-grid-vue";
import vSelect from 'vue-select';
import Vue from "vue";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");


export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererItem,
    CellSummaryDialog,
    ErrorDialog,
    vSelect
  },
  props: {
    isImportEditMode: { type: Boolean, default: false },
  },
  data() {
    return {
      importDate: "importedData", // name should be changed
      selectedDate: null,
      dateOptions: [],
      isReady: false,
      dispDate: "",
      displayDateList: [
        { id: "today",            name: "当日" },
        { id: "tomorrow",         name: "翌日" },
        { id: "dayAfterTomorrow", name: "翌々日" },
      ],
      selectedDisplayDateId: "today",
      destinationWorkTasks: [],
      filteredDestinationWorkTasks: [],
      activeListFlg: true,
      scrollUnlock: false,
      lastUpdate: 0,
      showPopupDate: false,
      clickX: -1,
      clickY: -1,
      popupTitle: "",
      popupTaskId: "",
      popupColumnKey: "",
      popupValueMap: null,

      // AgGrid-common
      components: {CellRendererItem},
      defaultColDef: {
        sortable: false,
        resizable: false,
        suppressMenu: true,
      },

      // AgGrid1
      gridApi1: null,
      columnDefs1: [],
      destinationWorkTasks1: [],
      gridOptions1: {
        localeText: { noRowsToShow: "入出港情報を取得中です。" },
        context: {
          componentParent: this,
          dragDisabled: true
        },
        suppressCellSelection: false,
        onRowDragEnd: this.onRowDragEnd,
        onCellMouseDown: this.onCellClicked,
        onCellKeyDown: this.onCellKeyDown,
        getRowStyle: params => {
          if (params.data.input_type.valueMap.value == 1) {
            return { background: 'rgba(45, 156, 219, 0.1)' };
          } else {
            return { background: 'none' };
          }
        },
        rowBuffer: 200
      },

      // AgGrid0
      isInsertOneMode: false,
      gridApi0: null,
      columnDefs0: [],
      destinationWorkTasks0: [],
      gridOptions0: {
        localeText: { noRowsToShow: "入出港情報を取得中です。" },
        context: { componentParent: this },
        suppressCellSelection: false,
        onCellMouseDown: this.onCellClicked,
        onCellKeyDown: this.onCellKeyDown,
      },

      inputs: {
        ropeBoats:      { label: "綱B", },
        vehicles:       { label: "車両", },
        progress:       { label: "進捗", },
        orderAt:        { label: "オーダー時", },
        orderType:      { label: "オーダー", },
        progressAt:     { label: "進捗時", },
        previous:       { label: "前泊地", },
        berth:          { label: "バース", },
        headCount:      { label: "人数", },
        vessel:         { label: "船舶名", },
        task:           { label: "タスク", },
        flag:           { label: "旗", },
        bit:            { label: "ビット", },
        boardsideType:  { label: "舷", },
        pilot:          { label: "水先", },
        tugBoats:       { label: "タグB", },
        cautions:       { label: "注意", },
        requiredNote:   { label: "備考", },
        weather:        { label: "天候", },
        teamLeader:     { label: "班長", },
        shippingAgency: { label: "代理店", },
        sortOrder:      { label: "並び順", },
        inputType:      { label: "取り込み種別判定", },
      },


    };
  },
  watch: {
    async selectedDate(value) {
      this.$vs.loading()
      this.setSelectedDateDisplay1(value)
      let payload = {
        hash: this.selectedPort.hash,
        date: this.selectedDate
      }
      await this.subscribeDestinationWorkTasks(payload)

      // 翌営業日以降を表示する場合、特定列は表示しない
      const excludeColumnsInFutureDay = ["vehicles", "rope_boats", "progress", "progress_at"];
      await this.fetchColumnsFromFirestore({
        hash: this.selectedPort.hash,
        excludeColumns: this.isFutureOnBusinessDay ? excludeColumnsInFutureDay : [],
      });
    },
    destinationWorkOneTask() {
      this.setDestinationWorkTasks(this.gridOptions0.api, this.destinationWorkOneTask );
    },
    lastUpdatedForTasks() {
      this.$nextTick(() => {
        const waitingMilliSec = 1200, waitingTermCount = 3;

        // データ登録と再描画処理でagGridのフォーカスが外れる場合の処理
        Array.from(Array(waitingTermCount).keys()).forEach(i => {
          setTimeout(() => {
            this.setFocusOnActiveGrid();
          }, (i + 1) * Math.floor(waitingMilliSec / waitingTermCount));
        });

        setTimeout(() => {
          this.redrawGrid();
          Vue.$log.debug("# ##### lastUpdatedForTasks changed.");
          this.isReady = true;
        }, waitingMilliSec); // TODO: 要タイミング調整
      });
    },
    lastUpdatedForColumns() {
      if ( this.isReady ) {
        this.lastUpdate = moment().valueOf();
        this.redrawGrid();
        Vue.$log.debug("## #### lastUpdatedForColumns changed.");
      }
    },
    lastUpdatedForMasters() {
      if ( this.isReady ) {
        this.lastUpdate = moment().valueOf();
        this.redrawGrid();
        Vue.$log.debug("### ### lastUpdatedForMasters changed.");
      }
    },
    lastUpdatedForMonitors() {
      if ( this.isReady ) {
        this.lastUpdate = moment().valueOf();
        this.redrawGrid();
        Vue.$log.debug("### ### lastUpdatedForMonitors changed.");
      }
    },
    activeListFlg() {
      Vue.$log.debug("##### # activeListFlg changed.");
      this.redrawGrid();
    },
    display1Active() {
      this.bindGridApi();
    },
    destinationWorkHeaders() {
      this.refreshColumnDefs();
    },
  },
  computed: {
    ...mapState({
      destinationWorkHeaders: state => state.destinationWorkHeaders,
      destinationWorkTasksMap: state => state.destinationWorkTasksMap,
      destinationWorkImportedTasksMap: state => state.destinationWorkImportedTasksMap,
      lastUpdatedForTasks: state => state.lastUpdatedForTasks,
      lastUpdatedForColumns: state => state.lastUpdatedForColumns,
      lastUpdatedForMonitors: state => state.lastUpdatedForMonitors,
      lastUpdatedForMasters:   state => state.lastUpdatedForMasters,
      lastUpdatedTimeMap: state => state.lastUpdatedTimeMap,
      monitorSettingMap: state => state.monitorSettingMap,
      selectedDateDisplay1: state => state.selectedDateDisplay1,
      vesselNameJapaneseFlg: state => state.vesselNameJapaneseFlg,
      destinationWorkOneTask: state => state.destinationWorkOneTask,
      selectedTaskId:          state => state.selectedTaskId,
      selectedColumnKey:       state => state.selectedColumnKey,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
      masterMap:               state => state.masterMap,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),
    filteredColumnDefs() {
      const filterColumns = ["order_type", "order_at", "previous", "berth", "head_count", "vessel", "bit", "flag", "boardside_type"];
      return JSON.parse(JSON.stringify(this.columnDefs1.filter(header => filterColumns.includes(header.field))));
    },
    isOneTaskValid() {
      return this.destinationWorkOneTask[0] ? Boolean(this.destinationWorkOneTask[0].order_at.valueMap.value)
                                              && Boolean(this.destinationWorkOneTask[0].order_type.valueMap) : true
    },
    isFutureOnBusinessDay() {
      // hour_intervalを考慮しつつ、selectedDateDisplay1が翌営業日以降か判定
      const hourIntervalObj = this.masterMap['tasks'].find(x => x.id === 'hour_interval');
      const hourIntervalString = hourIntervalObj ? hourIntervalObj.value : "00:00";
      const fromYmdhms = this.selectedDateDisplay1.replace(/^([0-9]{4})([0-9]{2})([0-9]{2})$/, "$1-$2-$3T") + hourIntervalString;
      return  moment(fromYmdhms).valueOf() > moment().valueOf() ;
    },    
    showPopupSync: {
      get() {
        return this.summaryDialogShowPopup;
      },
      set(val) {
        this.setSummaryDialogShowPopup(val);
        this.setFocusOnActiveGrid();
      }
    },
  },
  methods: {
    ...mapActions([
      "subscribeDestinationWorkTasks", "subscribeEventUpdate", "updateFirestoreDocument", "unsubscribeFirestore",
      "fetchSettings", "setSelectedDateDisplay1",  "setVesselNameJapaneseFlg",
      "fetchColumnsFromFirestore",
      "fetchDestinationWorkTasks", // Editでは追加
      "saveTasksToFirestore",
      "fetchOrderList",
      "setBlankTask", "submitDestinationWorkOneTask",
      "setIsImportEdit",
      "setSummaryDialogShowPopup",
      "setSelectedCell", "mergeUpdateDataIntoTaskRecord",
      "deleteAllDestinationWorkTask"
    ]),
    async openInsertOne() {
      // ag-grid-vue0 に一括セット

      this.isInsertOneMode = true;
      //this.setDestinationWorkTasks(this.gridOptions0.api, JSON.parse(JSON.stringify(dispTaskList.slice(0,1))));  // TODO: sliceは暫定。実際はvalueMapを空にした１行レコードを渡す。
      const initColumnKey = this.gridOptions0.api.columnModel.columnApi.getAllDisplayedColumns().filter(x => !['input_type', 'sort_order'].includes(x.colDef.field))[0].colDef.field;
      await this.setBlankTask({date:this.selectedDateDisplay1, initColumnKey: initColumnKey });
      Vue.$log.debug("this.destinationWorkOneTask", this.destinationWorkOneTask);

      this.setDestinationWorkTasks(this.gridOptions0.api, this.destinationWorkOneTask );
      // grid0 データ表示リロード
      if ( this.gridApi0 ) {
        // this.gridApi0.refreshCells({ force: true, suppressFlash: false, });
        // this.gridApi0.sizeColumnsToFit();
      }

    },
    async submitInsertOne() {
      try {
        this.$vs.loading()
        await this.submitDestinationWorkOneTask({date:this.selectedDateDisplay1, enterprisePort: this.selectedPort, });
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.isInsertOneMode = false
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let inputsKey = Object.keys(this.inputs).find(x => element.target.replace(/^.*\./, '') === x );
            let label = this.inputs[inputsKey] ? this.inputs[inputsKey].label : element.target;
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    },
    clickRowSortButton() {
      this.gridOptions1.context.dragDisabled = !this.gridOptions1.context.dragDisabled
    },
    setHeaderPositon() {
      if ( this.$refs.agGridTable1 ) {
        // 船舶の日本語/英表記の切り替え
        let agHeaderCellText = this.$refs.agGridTable1.$el.querySelectorAll(".ag-header-cell-text");
        const vesselHeader= this.destinationWorkHeaders.find(header => header.columnKey === "vessel");
        let foundVesselHeaderElement = Array.from(agHeaderCellText).find(el => el.innerText.trim().startsWith(vesselHeader.name));
        if ( foundVesselHeaderElement ) {
          foundVesselHeaderElement.innerHTML =
          vesselHeader.name + (this.vesselNameJapaneseFlg ? "　<span style='color:#2d9cdb;'>JP</span>/EN" : "　<span>JP</span>/<span style='color:#2d9cdb;'>EN</span>");

          const vesselRect =  foundVesselHeaderElement.getBoundingClientRect();
          let vesselOverlayCss = document.getElementById("vessel-header").style;
          vesselOverlayCss.marginTop    = '5px';
          vesselOverlayCss.left   = ( vesselRect.left   -110 ) + 'px';
          vesselOverlayCss.height = ( vesselRect.height +30 ) + 'px';
          vesselOverlayCss.width  = ( vesselRect.width  +20 ) + 'px';
        }
      }
    },
    toggleVesselNameJapaneseFlg() {
      if ( this.$refs.agGridTable1 ) {
        // 船舶の日本語/英表記の切り替え onmousedownイベントを上書き
        let agHeaderCellText = this.$refs.agGridTable1.$el.querySelectorAll(".ag-header-cell-text");
        const vesselHeader= this.destinationWorkHeaders.find(header => header.columnKey === "vessel");
        let foundVesselHeaderElement = Array.from(agHeaderCellText).find(el => el.innerText.trim().startsWith(vesselHeader.name));
        if ( foundVesselHeaderElement ) {
            const newVesselNameJapaneseFlg = !this.vesselNameJapaneseFlg;
            foundVesselHeaderElement.innerHTML = newVesselNameJapaneseFlg ?
              vesselHeader.name + "　<span style='color:#2d9cdb;'>JP</span>/EN":
              vesselHeader.name + "　JP/<span style='color:#2d9cdb;'>EN</span>";
            this.setVesselNameJapaneseFlg(newVesselNameJapaneseFlg);
        }
      }
    },
    convertToDisplayDate(date) {
      let displayDate = moment(date).format('YYYY/MM/DD')
      let timeRange = this.displayTimeRange()
      return displayDate + timeRange
    },
    displayTimeRange() {
      const hourIntervalObj = this.masterMap['tasks'].find(x => x.id === 'hour_interval');
      let hourIntervalString = hourIntervalObj ? hourIntervalObj.value : "00:00";
      let fromTime = moment("2000-01-01T" + hourIntervalString).format("HH:mm")
      let toTime = moment("2000-01-01T" + hourIntervalString).add(-1, "minutes").format("HH:mm")
      return ` ${fromTime} ~ 翌${toTime}`
    },
    async clickSaveButton() {
      let payload = {
        tasksData: this.destinationWorkImportedTasksMap,
        date: this.importDate,
        enterprisePort: this.selectedPort,
      }
      this.$vs.loading()
      try {
        await this.saveTasksToFirestore(payload)
        await this.deleteAllDestinationWorkTask()
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })

        this.$router.push(
          {
            name: "addon-port-master-destination-order-list"
          }
        )

      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let inputsKey = Object.keys(this.inputs).find(x => element.target.replace(/^.*\./, '') === x );
            let label = this.inputs[inputsKey] ? this.inputs[inputsKey].label : element.target;
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    },
    clickColumnSortButton() {
      this.$router.push(
        {
          name: "addon-port-master-destination-work-column-edit"
        }
      )
    },
    async redrawGrid(){
      // Display1は 当日(or翌日or翌々日)の全件。
      if ( ! this.monitorSettingMap[1] ) {
        return;
      }
      Vue.$log.debug("monitorSettingMap[1]", this.monitorSettingMap[1]);

      const targetDateStr = this.selectedDateDisplay1;
      let dispTaskList = [];
      let destinationWorkTasks = {}
      if (this.isImportEditMode) {
        destinationWorkTasks =  this.destinationWorkImportedTasksMap;
      } else {
        destinationWorkTasks =  this.destinationWorkTasksMap[targetDateStr];
      }
      Vue.$log.debug("### destinationWorkTasks", destinationWorkTasks );
      if (destinationWorkTasks) {

        for( let taskId of Object.keys(destinationWorkTasks) ){
          let dispTask = destinationWorkTasks[taskId];

          dispTask.id = taskId;
          dispTaskList.push(Object.assign({},dispTask));
        }
      }
      dispTaskList.sort((a, b) => {
        // sort_orderでソート
        let comparison = 0;
        if (a.sort_order.valueMap.value > b.sort_order.valueMap.value) {
          comparison = 1;
        } else if (a.sort_order.valueMap.value < b.sort_order.valueMap.value) {
          comparison = -1;
        } else {
          // 第２ソートは オーダー時間
          if ( a.order_at.valueMap.value > b.order_at.valueMap.value ) {
            comparison = 1;
          } else if ( a.order_at.valueMap.value < b.order_at.valueMap.value ) {
            comparison = -1;
          }
        }
        return comparison ;
      });
      Vue.$log.debug("dispTaskList = ", dispTaskList);
      this.setDestinationWorkTasks(this.gridOptions1.api, dispTaskList);

      // grid1 データ表示リロード
      if ( this.gridApi1 ) {
        this.gridApi1.refreshCells({ force: true, suppressFlash: false, });
        this.gridApi1.sizeColumnsToFit();
      }

      if (!this.isImportEditMode) {
        let dateOptions = await this.fetchOrderList(this.selectedPort)
        this.dateOptions = dateOptions.map(element => element.date)
      }

      this.setHeaderPositon();
      this.setFocusOnActiveGrid();
      this.$vs.loading.close()
    },
    setDestinationWorkTasks(gridOptionsApi, newDestinationWorkTasks) {
      // ag-grid-vueの行更新.
      // 現状(2021-03-04)は、受領した newDestinationWorkTasksを"正"として、 行単位に上書きすることで、チラつきを抑える。
      // 画面側で編集中なので上書きしたくない、１セルだけをピンポイントで更新したい、については後日検討予定。
      let lastIndex = -1;
      gridOptionsApi.forEachNode((rowNode, index) => {
        if (  newDestinationWorkTasks[index] ) {
          // update

          // agGridとstateのvalueMapを比較して、変化を検知した時だけupdate
          let valudMapDiffList = [];
          for ( let key of Object.keys(rowNode.data) ) {

            if ( !["docData"].includes(key) ) {
              if ( rowNode.data[key].valueMap && newDestinationWorkTasks[index][key].valueMap ) {
                const taskJsonAtGrid  = JSON.stringify(this.objectSort(rowNode.data[key].valueMap));
                const taskJsonAtState = JSON.stringify(this.objectSort(newDestinationWorkTasks[index][key].valueMap));
                if( taskJsonAtGrid !== taskJsonAtState ) {
                  valudMapDiffList.push( key );
                }
              } else if ( rowNode.data[key].valueMap === undefined && newDestinationWorkTasks[index][key].valueMap) {
                  valudMapDiffList.push( key );
              } else if ( rowNode.data[key].valueMap && newDestinationWorkTasks[index][key].valueMap === undefined ) {
                  valudMapDiffList.push( key );
              }
            }

          }

          if ( valudMapDiffList.filter(x => !!x).length > 0 ) {
            // update
            rowNode.setData(JSON.parse(JSON.stringify(newDestinationWorkTasks[index])));
          }

          lastIndex = index;
        } else {
          // delete
          gridOptionsApi.applyTransaction({ remove: [rowNode.data] });
        }
      });
      if ( lastIndex + 1 < newDestinationWorkTasks.length  ) {
        // insert
        gridOptionsApi.applyTransaction({
          add: newDestinationWorkTasks.slice(lastIndex + 1),
        });
      }
    },

    refreshColumnDefs() {

      this.columnDefs1 = this.destinationWorkHeaders.filter(header => {
        return !["highlight", "first_line_at"].includes(header.columnKey) // Editではhighlight,first_lineカラムは表示しない
      }).map(header => {
        return {
          field:      (header.columnKey === "sort_order" ? "sort_order" : header.columnKey ),
          rowDrag:    (header.columnKey === "sort_order" ? true : false ),
          rowDragText: (params) => {
            return params.defaultTextValue.valueMap.order_at_string ? params.defaultTextValue.valueMap.order_at_string : null
          },
          headerName: (header.columnKey === "sort_order" ? "" : header.name ),
          width:      (header.width ? header.width : null),
          suppressMovable:       true,
          cellRendererFramework: "CellRendererItem",
          cellClass:             'pm-ag-grid-cell',
          cellRendererParams:    { displayNumber: 1 },
          // autoHeight: true,  // autoHeight=true にすると、はみ出した時に２行になる。
        };
      });

      this.columnDefs1.unshift(
        {
          field:      "input_type",
          rowDrag:    false,
          headerName: "",
          width:      20,
          cellRendererFramework: "CellRendererItem",
          cellClass:             'pm-ag-grid-cell',
          cellRendererParams:    { displayNumber: 1 },
        }
      )
      Vue.$log.debug("columnDefs1", this.columnDefs1);

      if (this.gridApi1) {
        this.gridApi1.setColumnDefs(this.columnDefs1);
        this.gridApi1.setDomLayout('autoHeight');
      }

      this.columnDefs0 = JSON.parse(JSON.stringify(this.columnDefs1));
      if (this.gridApi0) {
        this.gridApi0.setColumnDefs(this.columnDefs1);
        this.gridApi0.setDomLayout('autoHeight');
      }
    },
    objectSort(obj){

      // ソートする
      const entries = ( typeof obj === "object" && obj !== null) ? Object.entries(obj) : [obj];
      const sorted = entries.sort() ;

      for(let i in sorted){
        if ( Array.isArray(sorted[i]) ) {
          const val = sorted[i][1];
          if(typeof val === "object"){
            // valueを調べ、objectならsorted entriesに変換する
            sorted[i][1] = this.objectSort(val);
          }
        }
      }

      return sorted.filter(x => !!x && !!x[1]);
    },
    async updateGridCell(updateData) {

      const newTaskWithName = await this.mergeUpdateDataIntoTaskRecord(updateData);

      if ( updateData.isInsertOneMode !== true ) {
        // agGrid1の対象行に直接更新。
        this.gridOptions1.api.forEachNode((rowNode, _) => {
          const taskId = rowNode.data[this.selectedColumnKey] ? rowNode.data[this.selectedColumnKey].taskId : null;
          if ( taskId === this.selectedTaskId ) {
            rowNode.setData(newTaskWithName);
          }
        });

      } else {
        // agGrid0の対象行に直接更新。
        this.gridOptions0.api.forEachNode((rowNode, _) => {
          rowNode.setData(newTaskWithName);
        });

      }

      if(updateData.toNextColumn) {
        let index = this.destinationWorkHeaders.findIndex(element => element.columnKey == updateData.columnKey)
        if (this.destinationWorkHeaders[index + 1]) {
          let nextColumnKey = this.destinationWorkHeaders[index + 1].columnKey;
          let taskId = updateData.taskId
          let valueMap = {}
          if (this.isImportEditMode) {
            valueMap = this.destinationWorkImportedTasksMap[Number(taskId)][nextColumnKey].valueMap
          } else if (updateData.isInsertOneMode){
            valueMap = this.destinationWorkOneTask[0][nextColumnKey].valueMap
          } else if (!updateData.isInsertOneMode){
            valueMap = this.destinationWorkTasksMap[this.selectedDate][taskId][nextColumnKey].valueMap
          }
          let payload = {
            value: {
              taskId: taskId,
              columnKey: nextColumnKey,
              valueMap: valueMap,
            }
          }
          this.onCellClicked(payload)
        }
      }
    },
    onRowDragEnd: function(evt) {
      Vue.$log.debug("onDraggableEnd", evt);
      const sortOrderDataList = this.$refs.agGridTable1.getRowData().map((rowData,index) => {
        return {
          taskId: Object.values(rowData).find(x => x.taskId).taskId,
          enterprisePort: this.selectedPort,
          data:{ sort_order: index },
        };
      });
      Vue.$log.debug("destinationWorkTasks",this.destinationWorkTasks);  // ドラッグしても、こっちは変化しなかった。

      Vue.$log.debug("sortOrderDataList",sortOrderDataList.map(e => e.taskId));
      sortOrderDataList.forEach(sortOrderData => { sortOrderData.enterprisePort = this.selectedPort; this.updateFirestoreDocument(sortOrderData, false)}); // TODO: 後で一括登録。
    },

    onCellClicked: function(evt) {
      Vue.$log.debug('A cell was clicked', evt.value);
      this.setSelectedCell(evt.value);

// Editでは クリック→→ポップアップさせる列名をここでフィルタリングする。

      const clickPopupColumnKeys = ['required_note', 'progress_at', 'previous', 'shipping_agency', 'order_type', 'order_at', 'progress', 'berth', 'vessel', 'vehicles', 'tug_boats', 'head_count', 'rope_boats', 'boardside_type', 'flag', 'bit', 'pilot', 'team_leader', 'caution_note', 'weather'];
      if (!clickPopupColumnKeys.includes(evt.value.columnKey)) {
        return;
      }
      if (evt.value.columnKey == 'progress_at' && !evt.value.valueMap.progress) {
        return;
      }

      let destinationWorkHeader = this.destinationWorkHeaders.find(header => header.columnKey === evt.value.columnKey)
      this.popupTitle = destinationWorkHeader ? destinationWorkHeader.name : '' ;
      this.popupTaskId = evt.value.taskId;
      this.popupColumnKey = evt.value.columnKey;
      this.popupValueMap = evt.value.valueMap;
      this.clickX = evt.event ? evt.event.clientX : 0;
      this.clickY = evt.event ? evt.event.clientY : 0;

      this.setFocusOnActiveGrid();
      this.showPopupSync=true;

    },
// Editでは追加
    onCellKeyDown: function(evt){
      Vue.$log.debug("onCellKeyDown", evt);
      if( evt.event.code.toUpperCase() === "ENTER" ){ // keyCode = 13
        Vue.$log.debug("Enter detected.");
      }
    },
    onChangeDate() {
      this.setSelectedDateDisplay1(this.selectedDisplayDateId);
      this.showPopupDate = false;
    },
    onScrollUnlock() {
      this.scrollUnlock = !this.scrollUnlock;
    },
    bindGridApi() {
      // 以下は、ag-grif-vueが実体化されたあとにセットする必要がある。v-show, v-ifで注意。
      this.gridApi1  = this.display1Active ? this.gridOptions1.api : null;
      this.gridApi0  = this.gridOptions0.api;
    },
    setFocusOnActiveGrid() {
      // ag-grid内の作業中セルにフォーカスする (setFocusedCell())
      if ( this.isInsertOneMode && this.gridOptions0) {
        const colObj = this.gridOptions0.api.columnModel.columnApi.getAllDisplayedColumns().find(x => x.colDef.field === this.selectedColumnKey);
        if ( colObj && this.showPopupSync === false  ) {
          this.gridOptions0.api.setFocusedCell(0, colObj.colId);
        }
      } else if ( this.gridOptions1 && this.$refs.agGridTable1 )  {
        const rowIndex = this.$refs.agGridTable1.getRowData().findIndex(rowData =>
          Object.values(rowData).find(x => x.taskId).taskId === this.selectedTaskId
        );
        const colObj = this.gridOptions1.api.columnModel.columnApi.getAllDisplayedColumns().find(x => x.colDef.field === this.selectedColumnKey);
        if ( colObj && this.showPopupSync === false ) {
          this.gridOptions1.api.setFocusedCell(rowIndex, colObj.colId);
        }
      }
    },
  },
  async created() {
    this.setIsImportEdit(this.isImportEditMode)
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.$vs.loading()
    await this.fetchSettings(this.selectedPort); // カラム情報、マスター情報を更新
    await this.subscribeEventUpdate(this.selectedPort);

    if (!this.isImportEditMode) {
      let dateOptions = await this.fetchOrderList(this.selectedPort)
      this.dateOptions = dateOptions.map(element => element.date)

      this.selectedDate = this.$route.params['date'] ? this.$route.params['date'] : (this.selectedDateDisplay1 ? this.selectedDateDisplay1 : dateOptions[0].date)
    } else {
      this.redrawGrid()
    }
    this.$vs.loading.close()
  },
  mounted() {
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable1.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }

    this.selectedDisplayDateId = this.selectedDateDisplay1;

    moment.locale("ja");
    setInterval(() => {
      this.dispDate = moment().local().format("YYYY/MM/DD(ddd) HH:mm");
    }, 1 * 1000);

    this.bindGridApi();

    // ブラウザバック禁止
    history.pushState(null, null, location.href);
    window.addEventListener('popstate', (_) => {
    history.go(1);
});

  },
  beforeDestroy() {
    this.unsubscribeFirestore();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#addon-port-master-destination-work-list {
  min-height: calc(100vh - 0px);
  .upper-controller {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    .save-button {
      margin-left: auto;
      width: 160px;
    }
  }
  .top-button {
    height: 42px;
    margin-left: 20px;
  }
  .button-inner {
    display: flex;
    align-items: center;
  }
  .last-updated-text {
    margin-left: auto;
  }
  .display-label {
    margin-right: 10px;
  }
  .import-date-label {
    margin-left: 20px;
  }
  .icon-area {
    display: flex;
    justify-content: center;
    margin-right: 10px;
  }
  .display-items-select-box {
    width: 260px;
  }
  // ag-grid-vue のヘッダ部分
  .ag-theme-material .ag-header-cell, .ag-theme-material .ag-header-group-cell {
    padding-left: 0 !important;
    padding-right: 0;
    font-weight: normal;
    font-size: 80%;
    color: $pm-black;
  }
  .ag-body-viewport {
    .ag-row-hover {
      background-color: #fafafa !important;
    }
  }
}

.vs-con-input-label {
  width: inherit;
}

.pm-ag-grid-vue {
  padding-left:20px;
  padding-right:20px;
  padding-bottom: 0px;
  height:calc(100vh - 110px);
}
.pm-ag-grid-cell {
  padding: 0 !important;
  margin: 0 auto;
  color: $pm-black;
  text-align: left;
}


[dir] .ag-theme-material .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
  height: calc(100% - 4px) ;
  margin: 2px 0;
  padding: 0px 0 0 0 ;
  background-color: #2d9cdb32;
  border-radius: 6px;
  border: none;
}

.pmdw-popup {
  header {
    h3 {
      text-align: center;
      background-color: white;
    }
    i {
      border-radius:20px;
      border: 2px solid $pm-white;
    }
    background-color: white;
  }

  .vs-popup--close {
    transform: translate(-10px,10px);
    &:hover {
      transform: translate(-10px,8px);
    }
  }
}
.ag-header-viewport {
  overflow-x: hidden;
}
.ag-body-viewport {
  height:calc(100vh - 160px);
  overflow-y: auto !important;
}
.ag-header-cell-text {
  padding-left: 0.25rem;
}
.ag-row .ag-cell {
  display: flex;
  align-items: center;
}
.ag-theme-material .ag-cell {
  line-height: 1rem;
}
.drag-disabled {
  .ag-drag-handle {
    display: none !important;
  }
}
.ag-ltr .ag-row-drag {
  margin: 0px 12px;
}

.insert-one-overlay{
  /* 要素を重ねた時の順番 */
  z-index:998;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;

}

.insert-one-content{
  z-index:999;
  width:80vw;
  height:16rem;
  padding: 1em;
  background:#ffffff;
  border-radius:4px;

  .pm-ag-grid-vue {
    height: auto;
  }
  .ag-body-viewport {
    height:calc(4rem);
    overflow-y: auto !important;
  }

  .insert-one-close-button {
    cursor: pointer;
    margin:0;
    padding:0.1rem 0.6rem;
    color:$pm-blue;
    background-color:#ffffff;
    font-size:170%;
    line-height: 1.2;
    border-radius:10%;
    transform: translate(60%,-60%);
    box-shadow: -1px 1px 1px 1px rgba(192,192,192,0.6);
  }

  .functions {
    display: none;
  }
  .ag-center-cols-clipper {
    height: 55px !important;
  }
}
.pm-click-jacking {
  position: absolute;
  z-index: 999;
}
</style>
